/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//console.log(window.currency.shop_curr);
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.currency.shop_curr;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class changeVariant extends HTMLElement {
  constructor(){
    super();
    this.selector = this.querySelector(".single-option-selector");
    this.selector.addEventListener("change", this.changeDetails.bind(this));
  }

  changeDetails(event){
    this.updateOption();
    this.getCurrentVar();
    this.updateId();
    this.renderProductInfo(event);
  }

  /* get checked value */
  updateOption(){
    const fields = Array.from(this.querySelectorAll("fieldset"));
    this.options = fields.map((field_set) => {
      return Array.from(field_set.querySelectorAll('option')).find((option) => option.selected).value;
    });
  }

  /* get current variant */
  getCurrentVar(){
    this.curr_variant = this.getVarList().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateId(){
    if(!this.curr_variant) return;
    const form = this.closest(".product-item__info").querySelectorAll('.product-item__action-list');
    form.forEach((frm) => {
      frm.querySelector("input[name='id']").value = this.curr_variant.id;
    });
  }

  renderProductInfo(eve){
    if(!this.curr_variant) return;
    if(this.curr_variant.compare_at_price > this.curr_variant.price){
      if(this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price--compare")){
        this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price--compare").style.display = 'block';
      }
      this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price").innerHTML = '<span class="visually-hidden">Sale price</span>'+Shopify.formatMoney(this.curr_variant.price)+'</span>';
      this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price--compare").innerHTML = '<span class="visually-hidden">Regular price</span>'+Shopify.formatMoney(this.curr_variant.compare_at_price);
    }else if(this.curr_variant.compare_at_price != 'null' && this.curr_variant.compare_at_price == this.curr_variant.price){
      this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price").innerHTML = '<span class="visually-hidden">Sale price</span>'+Shopify.formatMoney(this.curr_variant.price)+'</span>';
      if(this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price--compare")){
        this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price--compare").style.display = 'none';
      }
    }else{
      this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price").innerHTML = '<span class="visually-hidden">Sale price</span>'+Shopify.formatMoney(this.curr_variant.price)+'</span>';
      if(this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price--compare")){
        this.closest(".product-item__info").querySelector(".product-item__price-list").querySelector(".price--compare").style.display = 'block';
      }
    }
    this.updateAddToCartButton();
  }

  updateAddToCartButton(){
    const form = this.closest(".product-item__info").querySelector('.product-item__action-list');
    if(!form) return;
    const addButton = form.querySelector(".product-item__action-button");
    if(!addButton) return;

    if(this.curr_variant){
      if(!this.curr_variant.available){
        addButton.innerHTML = 'Sold out';
        addButton.setAttribute("disabled", "disabled");
      }else{
        addButton.innerHTML = 'Add to cart';
        addButton.removeAttribute("disabled", "disabled");
      }
    }else{
      addButton.innerHTML = 'Unavailable';
      addButton.removeAttribute("disabled", "disabled");
      const price = this.closest(".product-item__info").querySelector(".product-item__price-list");
      if(price) price.style.display = 'none';
    }
  }

  getVarList(){
    this.variant = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variant;
  }
}
customElements.define("vartiant-drop", changeVariant);